import React from 'react';
import SearchIcon from './icons/SearchIcon';
import XIcon from './icons/XIcon';

export interface SearchFieldProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    inputClassName?: string;
    iconClassName?: string;
    autoFocus?: boolean;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
    id?: string;
    clearLabel?: string;
    dir?: 'ltr' | 'rtl';
}

const SearchField: React.FC<SearchFieldProps> = ({
    value,
    onChange,
    placeholder,
    className = '',
    inputClassName = '',
    iconClassName = 'w-4 h-4',
    autoFocus,
    onKeyDown,
    id,
    clearLabel = 'Clear search',
    dir,
}) => {
    const hasValue = value.length > 0;
    const isRtl = dir === 'rtl';

    const inputPadding = isRtl
        ? hasValue ? 'pr-10 pl-10' : 'pr-10 pl-4'
        : hasValue ? 'ps-10 pe-10' : 'ps-10 pe-4';

    return (
        <div className={`relative ${className}`} dir={dir}>
            <input
                id={id}
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                autoFocus={autoFocus}
                dir={dir}
                className={`w-full py-3 text-sm bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl focus:ring-2 focus:ring-brand-sage outline-none font-bold transition-all text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 text-start ${inputPadding} ${inputClassName}`}
            />
            <div className={`absolute top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 pointer-events-none ${isRtl ? 'right-3.5' : 'left-3.5'}`}>
                <SearchIcon className={iconClassName} />
            </div>
            {hasValue && (
                <button
                    type="button"
                    onClick={() => onChange('')}
                    className={`absolute top-1/2 -translate-y-1/2 bg-slate-200 dark:bg-slate-700 rounded-full p-0.5 text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 transition-colors ${isRtl ? 'left-3.5' : 'right-3.5'}`}
                    aria-label={clearLabel}
                >
                    <XIcon className="w-4 h-4" />
                </button>
            )}
        </div>
    );
};

export default SearchField;
